import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { RemoveState } from '../lib/machine-remove';
import { Button } from './ui/Button';

// A removal whose token cascade failed (#6563): the machine IS removed and has left the
// roster, but its access tokens are not all revoked. Never reported as a clean removal.
// One of the Fleet page's notices (`MachineRemovalNotices`), not the details panel's: it
// stays whatever the panel shows. "Retry revoking" goes through revoke
// (`createMachineRemove`), a refusal stays beside it, and "Dismiss" drops the warning.

export function MachineRemoveNotice(props: {
  readonly state: RemoveState;
  readonly busy: boolean;
  readonly onRetry: () => void;
  readonly onDismiss: () => void;
}): JSX.Element {
  return (
    <div class="alert alert--destructive" role="alert">
      <p class="alert__title">{t('fleet.panel.cascade_title', { name: props.state.name })}</p>
      <p class="alert__desc">{t('fleet.panel.cascade_body')}</p>
      <Show when={props.state.error}>{(msg) => <p class="alert__desc">{msg()}</p>}</Show>
      <div class="machine-removal__actions">
        <Button variant="outline" size="sm" disabled={props.busy} onClick={props.onRetry}>
          {t('fleet.panel.cascade_retry')}
        </Button>
        <Button
          variant="ghost"
          size="sm"
          disabled={props.busy}
          aria-label={t('fleet.panel.cascade_dismiss_aria', { name: props.state.name })}
          onClick={props.onDismiss}
        >
          {t('fleet.panel.cascade_dismiss')}
        </Button>
      </div>
    </div>
  );
}
